export default __webpack_public_path__ + "static/media/FIU_Online.973184a8.svg";